import styled from "@emotion/styled";
import { FC, useState } from "react";

import { Avatar, Button, SpacingToken, Text } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { Section } from "components/section";
import { getTeamAgents } from "helpers/team";
import { IAgent } from "store/entities/agents";
import { ITeam } from "store/entities/teams";
import { textEllipsisStyles } from "styles/common";
import { withVar } from "themes/helpers";

const AGENTS_LIST_BREAKPOINT = 3;

interface IProps {
  agents: IAgent[];
  team: ITeam;
}

export const TeamDetails: FC<IProps> = ({ agents, team }) => {
  const [extendedMemberList, setExtendedMemberList] = useState(false);
  const teamAgents = getTeamAgents(team, agents);
  const filteredTeamAgents = extendedMemberList ? teamAgents : teamAgents.slice(0, AGENTS_LIST_BREAKPOINT);
  const hiddenAgentsCount = team.agentIds.length - AGENTS_LIST_BREAKPOINT;

  const toggleMembersList = (): void => {
    setExtendedMemberList(extendedMemberList => !extendedMemberList);
  };

  return (
    <StyledDetails>
      <Section title="Agents">
        <SectionContent>
          {filteredTeamAgents.map(agent => (
            <Member key={agent.id}>
              <Avatar
                type={agent.avatar ? "image" : "text"}
                src={agent.avatar ? agent.avatar : undefined}
                text={agent.name ?? agent.email}
                size="xxsmall"
              />
              <Text size="sm" title={agent.name} css={textEllipsisStyles}>
                {agent.name}
              </Text>
            </Member>
          ))}
          {team.agentIds.length > AGENTS_LIST_BREAKPOINT && (
            <Button kind="link" size="compact" onClick={toggleMembersList}>
              {extendedMemberList ? `Hide ${hiddenAgentsCount}...` : `Show ${hiddenAgentsCount} more...`}
            </Button>
          )}
        </SectionContent>
      </Section>
    </StyledDetails>
  );
};

const StyledDetails = styled.div`
  position: relative;
  padding: ${withVar(SpacingToken.Spacing4)};
  overflow: auto;
  height: 100%;
  box-sizing: border-box;
`;

const Member = styled(Flex)`
  width: 100%;
  align-items: center;
  gap: ${withVar(SpacingToken.Spacing2)};
`;

const SectionContent = styled.div`
  padding: ${withVar(SpacingToken.Spacing3)} ${withVar(SpacingToken.Spacing2)};
  overflow: auto;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: ${withVar(SpacingToken.Spacing3)};
`;
